<sbnb-thermostat-preset-adjustment
  [config]="{
    title: 'Long-Term Unoccupied',
    question: 'for extended gaps',
    icon: 'long-term-unoccupied',
    continueRoute: 'done',
    presetType: 'long-term-unoccupied'
  }">
  <p>
    The
    <strong>Long-Term Unoccupied preset</strong>
    activates
    <strong>at check-out</strong>
    if the property will be vacant for more than
    <strong>two weeks.</strong>
    This mode maximizes energy savings during extended gaps.
  </p>

  <p>
    <strong>Two days</strong>
    before the
    <strong>next check-in,</strong>
    the system will switch to the
    <strong>Unoccupied preset,</strong>
    gradually adjusting the temperature to reduce strain on the HVAC system.
  </p>
</sbnb-thermostat-preset-adjustment>
